// export const canAccess = (permissions, module, action = "view") => {
//   if (!permissions || !module) return false;

//   return Boolean(permissions[module?.toLowerCase()]?.[action]);
// };

export const canAccess = (permissionMap, module, action = "view") => {
  if (!permissionMap || !module) return false;

  return (
    permissionMap?.[module?.toLowerCase()]?.[action] === true
  );
};



// export const canAccess = (
//   accessModules = [],
//   moduleName,
//   action = "view"
// ) => {
//   if (!Array.isArray(accessModules)) return false;

//   const module = accessModules.find(
//     (m) => m.moduleName.toLowerCase() === moduleName.toLowerCase()
//   );

//   if (!module) return false;

//   return module.permissions?.[action] === true;
// };
